<template>
  <v-card>
    <v-list nav dense>
      <v-subheader
        ><span class="font-weight-bold">PIÈCES VERSÉES</span></v-subheader
      >
      <v-divider></v-divider>
      <v-list-item
        class="mt-0 pt-0 mb-n4 pb-n4"
        v-for="(pieceEtudiant, index) in piecesEtudiant"
        :key="index"
        three-line
        ><a :href="afficherPiece(pieceEtudiant.id)" title="Voir le contenu">
          <v-list-item-content>
            <v-list-item-subtitle
              ><v-icon class="primary--text">mdi-download</v-icon
              >{{ pieceEtudiant.libelleType }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </a>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import { mapState } from "vuex";

export default {
  name: "ListePiecesEtudiant",
  props: ["idEtudiant", "idFormation"],

  data() {
    return {
      piecesEtudiant: [],
      pieceEtudiant: {}
    };
  },
  computed: {
    ...mapState(["user"])
  },
  async created() {
    if (this.user.roles.indexOf("ROLE_ETUDIANT") > -1) {
      if (this.idFormation) {
        await this.getMesPiecesEtudiant(this.idFormation);
      }
    } else {
      if (this.idEtudiant > 0 && this.idFormation) {
        await this.getPiecesEtudiant(this.idEtudiant, this.idFormation);
      }
    }
  },
  methods: {
    async getPiecesEtudiant(idEtudiant, idFormation) {
      try {
        const pieces = await ApiEtudiantRepository.getPiecesEtudiantFormation(
          idEtudiant,
          idFormation
        );
        this.piecesEtudiant = pieces;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getMesPiecesEtudiant(idFormation) {
      try {
        const pieces = await ApiEtudiantRepository.getMesPiecesEtudiantFormation(
          idFormation
        );
        this.piecesEtudiant = pieces;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    afficherPiece(idPiece) {
      return this.user.roles.indexOf("ROLE_ETUDIANT") > -1
        ? process.env.VUE_APP_BACKEND_API_URL +
            "/api/etudiants/pieces/" +
            idPiece
        : process.env.VUE_APP_BACKEND_API_URL +
            "/api/gestion/etudiants/" +
            this.idEtudiant +
            "/pieces/" +
            idPiece;
    }
  }
};
</script>
